const fixedHolidays = new Set(['01-01','04-23','05-01','05-19','07-15','08-30','10-29']);
const turkeyClock = new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Istanbul',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
function calendarDates(raw) {
  const dates = String(raw || '').trim().split(/[\s,;]+/).filter(Boolean);
  const valid = dates.every(value => /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0,10) === value);
  return {valid,dates:new Set(dates)};
}
export function dispatchDecision(date,config,state) {
  const result = {kind:'neutral',visible:false};
  if (!state.inStock) return {...result,kind:'unavailable'};
  if (!config.enabled) return result;
  const days = Number(state.leadDays || 0);
  if (Number.isInteger(days) && days > 0 && days <= 30) return {kind:'lead',visible:true,days};
  if (!state.eligible || days !== 0) return result;
  const cutoff = String(config.cutoff || '').trim().replace('.',':');
  if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(cutoff)) return result;
  const full = calendarDates(config.holidays), half = calendarDates(config.halfDays);
  const years = String(config.years || '').split(/[\s,;]+/).filter(Boolean);
  const parts = Object.fromEntries(turkeyClock.formatToParts(date).filter(p=>p.type!=='literal').map(p=>[p.type,p.value]));
  if (!years.includes(parts.year) || !full.valid || !half.valid) return result;
  const key = parts.year + '-' + parts.month + '-' + parts.day;
  const monthDay = parts.month + '-' + parts.day;
  const weekday = new Date(Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day))).getUTCDay();
  const minutes = Number(parts.hour)*60+Number(parts.minute);
  const halfDay = monthDay === '10-28' || half.dates.has(key);
  if (weekday === 0 || weekday === 6 || fixedHolidays.has(monthDay) || full.dates.has(key) || (halfDay && minutes >= 780)) return {kind:'holiday',visible:true};
  const cutoffMinutes = Number(cutoff.slice(0,2))*60+Number(cutoff.slice(3));
  const effectiveCutoff = halfDay ? Math.min(cutoffMinutes,780) : cutoffMinutes;
  if (minutes >= effectiveCutoff) return {kind:'next',visible:true};
  const formatted = String(Math.floor(effectiveCutoff/60)).padStart(2,'0') + '.' + String(effectiveCutoff%60).padStart(2,'0');
  return {kind:'today',visible:true,cutoff:formatted};
}
if (typeof window !== 'undefined' && !customElements.get('elteres-dispatch-controller')) {
  customElements.define('elteres-dispatch-controller',class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.root = document.getElementById('ProductSection-' + this.dataset.sectionId);
      this.details = this.root?.querySelector('product-details');
      const source = this.querySelector('[data-dispatch-config]');
      if (!this.details || !source) return;
      try { this.config = JSON.parse(source.textContent); } catch { return; }
      const stamp = Number(this.config.serverTime)*1000;
      this.anchor = Number.isFinite(stamp) && stamp > 0 ? stamp : Date.now();
      this.anchorPerformance = performance.now();
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(()=>{this.frame=0;this.update();});
      };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.details,{subtree:true,childList:true,attributes:true,attributeFilter:['data-in-stock','data-eligible','data-lead-days','data-variant-id']});
      this.onChanging = context => {
        if (context.sectionId !== this.dataset.sectionId) return;
        this.pending = true;
        this.expectedVariant = context.variant?.id ? String(context.variant.id) : null;
        this.schedule();
      };
      this.onUpdated = context => {
        if (context.sectionId !== this.dataset.sectionId) return;
        this.pending = false;
        this.schedule();
      };
      this.bus = window.eventBus;
      this.bus?.on('variant:change',this.onChanging);
      this.bus?.on('variant:updated',this.onUpdated);
      this.onVisibility = () => {
        if (!document.hidden) this.tick();
      };
      document.addEventListener('visibilitychange',this.onVisibility);
      this.tick();
    }
    now() { return new Date(this.anchor + performance.now() - this.anchorPerformance); }
    tick() {
      clearTimeout(this.timer);
      this.update();
      if (document.hidden) return;
      const wait = 60000 - (this.now().getTime() % 60000) + 30;
      this.timer = setTimeout(()=>this.tick(),wait);
    }
    update() {
      if (!this.root?.isConnected) return;
      const messages = this.config.messages;
      const stateNode = this.details.querySelector('[data-elteres-dispatch-message]');
      if (!stateNode) return;
      if (this.pending && this.expectedVariant && stateNode.dataset.variantId === this.expectedVariant) this.pending = false;
      const state = {inStock:stateNode.dataset.inStock==='true',eligible:stateNode.dataset.eligible==='true',leadDays:stateNode.dataset.leadDays};
      const decision = this.pending ? {kind:'neutral',visible:false} : dispatchDecision(this.now(),this.config,state);
      let title = messages[decision.kind] || messages.neutral;
      let detail = messages[decision.kind + '_detail'] || messages.neutral_detail;
      title = title.replaceAll('__DAYS__',String(decision.days || ''));
      detail = detail.replaceAll('__DAYS__',String(decision.days || '')).replaceAll('__CUTOFF__',decision.cutoff || '');
      this.details.querySelectorAll('[data-elteres-dispatch-message]').forEach(el=>{
        const hide = el.dataset.context === 'near_button' && !decision.visible;
        if (el.hidden !== hide) el.hidden = hide;
        const titleNode = el.querySelector('[data-dispatch-title]');
        const detailNode = el.querySelector('[data-dispatch-detail]');
        if (titleNode && titleNode.textContent !== title) titleNode.textContent = title;
        if (detailNode && detailNode.textContent !== detail) detailNode.textContent = detail;
        el.dataset.dispatchState = decision.kind;
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.bus?.off('variant:change',this.onChanging);
      this.bus?.off('variant:updated',this.onUpdated);
      document.removeEventListener('visibilitychange',this.onVisibility);
      clearTimeout(this.timer);
      cancelAnimationFrame(this.frame);
      this.started = false;
    }
  });
}
